export enum StatusConteudoAgendado {
  CONCLUIDO = 'done',
  DISPONIVEL = 'available',
  INDISPONIVEL = 'unavailable',
  COM_FEEDBACK = 'hasFeedback',
}
